import { Currency } from '@/constants';
import { AbstractModel } from '@/models/abstractModel';
import { IUserBalanceRowApi } from '@/types/userBalance';

export class UserBalanceItem extends AbstractModel {
    public balance: number;
    public balanceAgentEuro: number;
    public balanceAgentPc: number;
    public balanceBookmakerEuro: number;
    public balanceBookmakerPc: number;
    public betCount: number;
    public bookFeesEuro: number;
    public bookFeesPerc: number;
    public bookRebateEuro: number;
    public companyComEuro: number;
    public currencyId: number;
    public login: string;
    public playerCom: number;
    public playerComEuro: number;
    public playerComPc: number;
    public ptBalance: number;
    public settledBotCount: number;
    public settledStakeAgentSum: number;
    public settledStakeBookmakerSum: number;
    public settledStakeSum: number;
    public toolUserTypeId: number | null;
    public userId: number;

    constructor(data: IUserBalanceRowApi = {}, requestCurrencyId: number = Currency.Euro) {
        super();
        this.userId = data.ownerId ?? 0;
        this.login = data.login ?? '';
        this.toolUserTypeId = data.tool_user_type_id ?? null;
        this.betCount = data.bet_count ?? 0;
        this.settledBotCount = data.settled_bot_count ?? 0;
        this.settledStakeSum = data.settled_stake_sum ?? 0;
        this.settledStakeAgentSum = data.settled_stake_agent_sum ?? 0;
        this.balance = data.balance ?? 0;
        this.balanceAgentPc = data.balance_agent_pc ?? 0;
        this.playerCom = data.player_com ?? data.player_com_euro ?? 0;
        this.playerComPc = data.player_com_pc ?? 0;
        this.playerComEuro = data.player_com_euro ?? 0;
        this.settledStakeBookmakerSum = data.settled_stake_bookmaker_sum ?? 0;
        this.companyComEuro = data.company_com_euro ?? 0;
        this.bookFeesEuro = data.book_fees_euro ?? 0;
        this.bookFeesPerc = data.book_fees_perc ?? 0;
        this.bookRebateEuro = data.book_rebate_euro ?? 0;
        this.balanceBookmakerPc = data.balance_bookmaker_pc ?? 0;
        this.balanceBookmakerEuro = data.balance_bookmaker_euro ?? 0;
        this.balanceAgentEuro = data.balance_agent_euro ?? 0;
        this.ptBalance = data.pt_balance ?? 0;
        this.currencyId = data.currency_id ?? requestCurrencyId;
    }

    get agTotal(): number {
        if (!this.settledStakeSum) return 0;
        return this.balanceAgentPc + this.playerCom;
    }

    get companyPlEuro(): number {
        return this.balanceBookmakerEuro - this.balanceAgentEuro + this.companyComEuro - this.playerComEuro - this.bookFeesEuro + this.bookRebateEuro;
    }
}

export class UserBalanceStats extends UserBalanceItem {}
